export function getExternalClientName(client) {
  const data = client?.raw_data || client;
  return String(data?.razao_social || data?.nome_fantasia || data?.name || "").trim();
}
